import { calculatePageCount, calculatePageSegment } from '../Common/utils';

export const getRejectedFilters = state => state.rejected.rejectedFilters;

export const getCurrentSelectedRejected = state => state.rejected.currentSelectedRejected;

export const getCurrentVisitPayloadDetails = state =>
  state.rejected.currentRejectedDetails.visitPayload;

export const getRejectedPagination = state => {
  const { pageNumber, pageSize, totalRecords } = state.rejected.rejectedPagination;
  const pageCount = calculatePageCount(pageSize)(totalRecords);
  const pagesPerSegment = calculatePageSegment(pageCount);

  return {
    pageNumber,
    numberOfPages: pageCount,
    pagesPerSegment,
    totalRecords,
    pageSize,
  };
};

export const getRejectedGridSortCriteria = state => state.rejected.rejectedGridSortCriteria;
